import { transformProperties } from "@/utils/simplifyData"
import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"
import Image from "next/image"
import Link from "next/link"
import { colors, mediaQueries, sizes } from "ui"
import { getUmbracoMediaUrl } from "utils"

const StyledImage = styled(Image)`
  border-radius: 50%;
`

const StyledImageContainer = styled(Box)`
  position: relative;
  border-radius: 150px;
  width: 100px;
  height: 100px;
  ${mediaQueries.desktopM} {
    width: 180px;
    height: 180px;
    padding: 10px;
  }
`
const StyledBoxWrapper = styled(Box)`
  border-radius: ${sizes.borderRadius};
  background: rgba(255, 255, 255, 0.8);
  box-shadow: -4.297px 8.593px 32.225px 0px rgba(2, 1, 64, 0.12);
  backdrop-filter: blur(20.76602554321289px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${sizes.baseTriple};
  cursor: pointer;
  width: 100%;
  ${mediaQueries.desktopM} {
    width: auto;
  }
`
const StyledTitle = styled(Typography)<{ component?: string }>`
  padding-top: ${sizes.baseTriple};
  padding-bottom: ${sizes.baseSingle};
`
const StyledText = styled(Typography)<{ component?: string }>`
  text-align: center;
`
const StyledImageWrapper = styled(Box)`
  cursor: pointer;
  position: relative;
  width: 40px;
  height: 40px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

const StyledLink = styled(Link)`
  position: absolute;
  bottom: 0px;
  left: 0px;
`

const CircleImageCard = ({ item }: { item: any }) => {
  const { title, text, image, description, linkedinLink } = transformProperties(
    item?.properties,
  )

  const linkedinUrl = linkedinLink.links[0]?.url
  return (
    <StyledBoxWrapper>
      {image?.mediaItems && (
        <StyledImageContainer>
          <StyledImage
            src={getUmbracoMediaUrl(image?.mediaItems[0]?.url)}
            alt={title?.value}
            fill
          />
          {linkedinUrl && (
            <StyledLink
              href={linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <StyledImageWrapper>
                <Image alt="" src={"/linkdin-image.svg"} fill></Image>
              </StyledImageWrapper>
            </StyledLink>
          )}
        </StyledImageContainer>
      )}
      {title?.value && (
        <StyledTitle variant="h5" component="h3" color={colors.black}>
          {title?.value}
        </StyledTitle>
      )}
      {text?.value && (
        <StyledText variant="body1" component="h4" color={colors.red}>
          {text?.value}
        </StyledText>
      )}
      {description?.value && (
        <StyledText variant="body1" component="h4" color={colors.black}>
          {description?.value}
        </StyledText>
      )}
    </StyledBoxWrapper>
  )
}

export default CircleImageCard
